const lang={
    'es':{
        'inicio': 'inicio',
        'monitoreo': 'monitoreo',
        'administrador': 'administrador',
        'admin': 'administrador',
        'cis': 'cmdb',
        'mantto': 'mantenimiento',
        'portafolio': 'portafolio',
        'mantenimiento': 'mantenimiento',
        'reportes': 'reportes',
        'acciones': 'acciones',
        'buzon': 'buzón',
        'configuracion': 'configuración',
        'config': 'configuración',
        'salir': 'salir',
        'msgCredencialesEstado': 'Ingrese las credenciales correctas para este estado',
        'correo': 'correo',
        'contraseña': 'contraseña',
        'iniciandoSession': 'Iniciando sesión',
        'credencialesNoAceptadas': 'Credenciales no aceptadas',
        'msgUserErrorData': 'Su usuario cuenta con errores o está incompleto, favor de reportar con su administrador',
        'pingServer': 'Estableciendo ping con el servidor',
        'CargandoDatos': 'Cargando datos, por favor espere',
        'CargandoDatosError': 'Error al cargar datos de configuración',
        'msgCerrarsession': 'Cierre sesión y vuelva a intentar',
        'bienvenido': 'bienvenido',
        'buscar': 'buscar',
        'resultadosEncontrados': 'resultados encontrados',
        'sinResultados': 'sin resultados',
        'servicio': 'servicio',
        'nuevoServicio': 'nuevo servicio',
        'regresar': 'regresar',
        'catalogo': 'catálogo',
        'plantilla': 'plantilla',
        'de': 'de',
        'resultados': 'resultados',
        'descripcion': 'descripción',
        'severidad': 'severidad',
        'eliminar': 'eliminar',
        'aceptar': 'aceptar',
        'cancelar': 'cancelar',
        'msgServicioExiste': 'El nombre del servicio ya existe',
        'activo': 'activo',
        'inactivo': 'inactivo',
        'msgIpNoExiste': 'La IP no existe o no está dada de alta',
        'ipNoValida': 'Dirección IP no válida',
        'crear': 'crear',
        'editar': 'editar',
        'nombreServicio': 'Nombre del servicio',
        'guardar': 'guardar',
        'nuevaTecnologia': 'nueva tecnología',
        'tecnologia': 'tecnología',
        'horas': 'horas',
        'msgTecnologiaExiste': 'El nombre de tecnología ya existe',
        'nombreTecnologia': 'Nombre de la tecnología',
        'nuevosDispositivos': 'alta dispositivos',
        'ubicacion': 'ubicación',
        'nuevaConfiguracion': 'nueva configuración',
        'nombre': 'nombre',
        'marca': 'marca',
        'modelo': 'modelo',
        'version': 'versión',
        'noSerie': 'no. serie',
        'criticidad': 'criticidad',
        'registroConfiguracion': 'registro de configuración',
        'coordenadasErroneas': 'coordenadas erróneas',
        'nombreDispositivo': 'nombre de dispositivo',
        'referencia': 'referencia',
        'nuevoRegistro': 'nuevo registro',
        'tipo': 'tipo',
        'justificacion': 'justificación',
        'responsable': 'responsable',
        'autoriza': 'autoriza',
        'fechaInicio': 'fecha inicio',
        'fechaFin': 'fecha fin',
        'afectados': 'afectados',
        'documentacion': 'documentación',
        'afectadoPor': 'afectado por',
        'agregar': 'agregar',
        'tipoCambio': 'tipo de cambio',
        'accion': 'acción',
        'aplicados': 'aplicados',
        'exception': 'excepción',
        'agencia': 'agencia',
        'tiempoActivo': 'tiempo activo',
        'closeException': 'Se cerrará la excepción',
        'deleteException': 'Se eliminará la excepción',
        'folio': 'folio',
        'quienSolicita': 'Quién solicita',
        'fechaSolicitud': 'fecha solicitud',
        'requizito': 'requisito',
        'comentarios': 'comentarios',
        'rechazar': 'rechazar',
        'solicitadoPor': 'solicitado por',
        'config-agency': 'Configuración --> Agencias',
        'config-Cis': 'Configuración --> CMDB',
        'criticidades': 'criticidades',
        'agencias': 'agencias',
        'config-criticity': 'Configuración --> Criticidades',
        'icono': 'ícono',
        'previewIcon': 'previsualización ícono',
        'previewLayer': 'previsualización capa',
        'caracteres': 'caracteres',
        'selectColor': 'clic para seleccionar color',
        'agenciaExcepciones': 'Agencia de excepciones',
        'noDeleteAgency': 'No se puede eliminar esta agencia',
        'noDeleteAgencyDetail': 'Para poder eliminar esta agencia es necesario cerrar todas las excepciones asignadas a ella',
        'nivel': 'nivel',
        'admin-users': 'Administración --> Usuarios',
        'admin-rol': 'Administración --> Roles',
        'noti-user': 'Administración --> Notificaciones por usuario',
        'noti-tec': 'Notificaciones por tecnología',
        'msgErrorPagina': 'Error al cargar la sección. Por favor, inténtelo de nuevo.',
        'nombreNoValido': 'Nombre no válido',
        'correoNoValido': 'Correo no válido',
        'usuario': 'usuario',
        'usuarios': 'usuarios',
        'todos': 'todos',
        'todas': 'todos',
        'selecPermisos': 'Seleccione permisos',
        'consola': 'consola',
        'acciones host': 'acciones host',
        'acknownledge': 'acknowledge',
        'servidores genetec': 'servidores genetec',
        'servidores cad': 'servidores cad',
        'servidores botones': 'servidores botones',
        'servidores gemyc': 'servidores gemyc',
        'link ticket': 'link ticket',
        'RESET': 'RESET',
        'seleccionar': 'seleccionar',
        'tecnologias': 'tecnologías',
        'notiTec': 'Notificación tecnologías',
        'notiUser': 'Notificación usuarios',
        'reporte-disp': 'Reportes --> Disponibilidad',
        'reporte-historicDisp':'Reportes --> Historico Disponibilidad',
        'historicoDisp':'historico disponibilidad',
        'reporte-disp-host': 'Reportes --> Disponibilidad por host',
        'reporte-sla': 'Reportes --> SLA',
        'grupos': 'grupos',
        'grupo': 'grupo',
        'config-grupos': 'Configuración --> Grupos',
        'dispositivos': 'dispositivos',
        'filasPagina': 'filas por página',
        'descargando': 'descargando',
        'importar': 'importar',
        'datos': 'datos',
        'marcas': 'marcas',
        'proxies': 'Nodos de monitoreo',
        'config-proxies': 'Configuración --> Nodos de monitoreo',
        'config-tec': 'Configuración --> Tecnologías',
        'config-brand': 'Configuración --> Marcas',
        'cerrar': 'cerrar',
        'registrosCargar': 'registros por cargar',
        'sinArchivo': 'No se ha cargado ningún archivo',
        'selectFile': 'Seleccionar archivo',
        'registrosCorrectos': 'Registrados correctamente',
        'updateCorrectos': 'Actualizados correctamente',
        'registrosIncorrectos': 'Registros no válidos',
        'completado': 'completado',
        'regGenCorr': 'Registro generado correctamente',
        'regEditCorr': 'Registro editado correctamente',
        'regNoGenCorr': 'Registro no generado correctamente',
        'reportError': 'Favor de reportar el error',
        'regDeleteCorr': 'Registro eliminado correctamente',
        'importCorr': 'Importación de datos exitosa',
        'msgImpor': 'Se detectaron registros no validos para la importacion, favor de valdarlos',
        'msgImporAll':'Todos los regstros selecconados no son validos para la importacion',
        'importError': 'Error en la importación',
        'modo': 'modo',
        'lastConect': 'última conexión',
        'nombreVisible': 'nombre visible',
        'modelos': 'modelos',
        'config-models': 'Configuración --> Modelos',
        'config-hosts': 'Configuración --> Dispositivos',
        'config-correlacion':'Configuración --> Correlación Dispositivos',
        'confGeneral': 'configuración general',
        'confSNMP': 'Configuración SNMP',
        'confMetrica': 'configuración métricas',
        'dispositivo': 'dispositivo',
        'municipio': 'municipio',
        'zona': 'zona',
        'latitud': 'latitud',
        'longitud': 'longitud',
        'estatus': 'estatus',
        'discovery': 'descubrir',
        'agregarElemento': 'agregar elemento',
        'discoverCorrect': 'Obtención de datos completada',
        'descargar': 'descargar',
        'descargaFileCompleta': 'La exportación o descarga del archivo fue exitosa',
        'config-audit': 'Configuración --> Auditoría',
        'auditor': 'auditor',
        'fecha': 'fecha',
        'modulo': 'módulo',
        'respaldo': 'respaldo',
        'respaldo-op':'Respaldo --> Respaldo DB de Operación', // 'Operacíon' -> 'Operación'
        'respaldo-config':'Respaldo --> Respaldo DB de Configuración', // 'Configuracíon' -> 'Configuración'
        'encuestas':'encuestas',
        'encuesta':'encuesta',
        'encuestas-gen':'encuestas',
        'encuestas-res':'encuestas --> Encuestas - Resultados',
        'workflow':'flujo de trabajo',
        'workflow-gen':'flujo de trabajo',
        'gruposUsuarios':'Grupos de Usuarios',
        'admin-grupos':'Administración --> Grupos de Usuarios',
        'NotiUsuarios':'Notificaciones para usuarios',
        'portafolioServicios':'Portafolio de Servicios',
        'exepciones':'Excepciones', // 'Exepciones' -> 'Excepciones'
        'calendarioMantenimiento':'Calendario de Mantenimiento',
        'accionesTecnologia':'Acciones por Tecnologías', // 'Tecnologias' -> 'Tecnologías'
        'solicitudAutoriza':'Solicitudes de Autorización', // 'Autorizacion' -> 'Autorización'
        'respaldoConfig':'Respaldo DB - Configuración', // 'Configuracíon' -> 'Configuración'
        'respaldoOper':'Respaldo DB - Operación', // 'Operacíon' -> 'Operación'
        'encuestasResultados':'Encuestas - Resultados',
        'criticidadDispositivo':'Criticidades de Dispositivos',
        'gruposDispositivos':'Grupos de Dispositivos',
        'mediciones':'Mediciones',
        'disparadores':'Disparadores',
        'eventos':'Eventos',
        'mediosDifusion':'Medios de Difusión', // 'Difusion' -> 'Difusión'
        'gruposTelegram':'Grupos de Telegram',
        'plantillaTelegram':'Plantillas de Telegram',
        'lastReadTele':'Últimas Lecturas de Comandos de Telegram', // 'Ultimas' -> 'Últimas'
        'config-mediciones':'Configuración --> Mediciones',
        'config-disparadores':'Configuración --> Disparadores',
        'config-eventos':'Configuración --> Eventos',
        'config-medDif':'Configuración --> Medios de Difusión', // 'Difusion' -> 'Difusión'
        'config-telegram':'Configuración --> Grupos de Telegram',
        'config-platelegram':'Configuración --> Plantillas de Telegram',
        'config-lastReadTele':'Configuración --> Últimas Lecturas de Comandos de Telegram', // 'Ultimas' -> 'Últimas'
        'exportar':'exportar',
        'descubrirNuevosGrupos':'descubrir nuevos grupos',
        'msgVisualisarGrupos':'Para visualizar nuevos grupos:',
        'msgVisualisarGrupos1':'crear grupo en telegram desde cualquier cuenta',
        'msgVisualisarGrupos2':'Añadir como usuario al bot: @',
        'msgVisualisarGrupos3':'Asignar privilegios administrador en el grupo al bot: @',
        'msgVisualisarGrupos4':'Anviar codigo de autenticacion de grupo: ',
        'vincular':'vincular',
        'gruposDescubiertos':'Grupos Descubiertos',
        'descubrirGruos':'descubrir grupos',
        'vinculadoCorrect':'Grupo vinculado correctamente',
        'vinculadoInorrect':'Grupo no vinculado correctamente',
        'comando':'comando',
        'layout':'plantilla',
        'vars':'variables',
        'mensaje':'mensaje',
        'usuraio':'usuraio',
        'sendMessage':'Enviar Mensaje',
        'sendMessageTest':'Se enviara un mensaje de prueba al siguiente grupo',
        'txtAreaMsg':'Escribe aquí tu mensaje...',
        'sendMsgCorrect':'Mensaje enviado correctamente',
        'sendMsgIncorrect':'Mensaje no enviado correctamente',
        'enviar':'enviar',
        'manttoCalendar':'Calendario Mantenimiento',
        'mantto-excepciones':'Mantenimiento --> Excepciones',
        'mantto-calendar':'Mantenimiento --> Calendario',
        'titulo':'titulo',
        'alertas':'alertas',
        'evento':'evento',
        'closeEvents': 'Se cerrará el evento',
        'rangoFechas':'rango de fechas',
        'tipoMantenimiento':'tipo de mantenimiento',
        'afiliacion':'ubicación',
        'hostSelected':'Dispositivos seleccionados',
        'Aceptar':'Aceptar',
        'codigo':'codigo',
        'disparador':'disparador',
        'periodo':'periodo',
        'preguntas':'preguntas',
        'pregunta':'pregunta',
        'opciones':'opciones',
        'opcion':'opcion',
        'respuestas':'respuestas',
        'respuesta':'respuesta',
        'responder':'responder',
        'testGenCorr': 'Encuesta respondida correctamente',
        'testInCorr': 'Se produjo un error al registar sus respuestas',
        'tipoAgente':'tipo de agente',
        'tipoVariable':'tipo de variable',
        'unidad':'unidad',
        'actualizacion':'actualización',
        'plantillas':'plantillas',
        'itemName':'nombre de item',
        'keyItem':'clave de item',
        'metrica':'métrica',
        'intervaloActualizacion':'intervalo de actualizacíon',
        'templateGroup':'Grupo de plantilla',
        'templateName':'Nombre de plantilla',
        'medicion':'medición',
        'maxValue':'valor maxímo',
        'minValue':'valor minímo',
        'msgEvento':'Mensage de  evento',
        'recursos':'recursos',
        'siguiente':'siguiente',
        'notficacion':'notficación',
        'workflowAction':'flujo de acciones',
        'workflow-action':'flujo de trabajo --> flujo de acciones',
        'aplazar':'aplazar',
        'historicoEvents':'histórico de eventos',
        'eventsTickets':'eventos vs Tickets',
        'reporte-eventos-historic':'Reportes --> historico de eventos',
        'reporte-eventos-tickets':'Reportes --> eventos vs tickets',
        'fechaCreacion':'fecha de creación',
        'fechaRecuperacion':'fecha de recuperación',
        'fechaCierre':'fecha de cierre',
        'eventosDesconeccion':'eventos desconección',
        'conteoTickets':'conteo de tickets',
        'espacioTotal':'espacio total',
        'espacioUtilizado':'espacio utilizado',
        'configRespaldo':'configuración de respaldo',
        'frecuencia':'frecuencia',
        'hora':'hora',
        'diario':'diario',
        'semanal':'semanal',
        'diaSemana':'dia de la semana',
        'lunes':'lunes',
        'martes':'martes',
        'miercoles':'miércoles',
        'jueves':'jueves',
        'viernes':'viernes',
        'sabado':'sábado',
        'domingo':'domingo',
        'actualizar':'actualizar',
        'backHistory':'historico de respaldos',
        'fechaRespaldo':'fecha de respaldo',
        'configRespaldoComplete':'Configuración de copia de seguridad actualizada',
        'configRespaldoError':'Error al actualizar la configuración',
        'nuevaPetición':'nueva petición',
        'enviarPetcion':'enviar petición',
        'msgSendRequest':'Envíe su solicitud y el equipo de soporte se comunicará con usted lo antes posible.',
        'tipoPeticion':'tipo de petición',
        'seleccionarOpcion':'seleccionar opción',
        'dataRecovery':'recuperación de datos',
        'dataDestruction':'destrucción de datos',
        'reporte-BI':'Reportes --> BI',
        'Incidencia':'Incidencia',
        'Estatus':'Estatus',
        'tiempoEvento':'tiempo',
        'problema':'problema',
        'LastAck':'ultimo ack',
        'tiempoGarantia':'tiempo de grarantia',
        'regDeleteNoCorr': 'no se pudo eliminar el registro',
        'reporte-kpi': 'Reportes --> KPI´S',
        'reporte-graph-kpi':'Reportes -->  KPI´S',
        'grafica':'grafica',
        'reporte-graph-metrica':'Reportes -->  Medición',
        'tipoOperacion':'tipo de operación',
        'conexionesEstado':'Conexiones por estado',
        'hostTotalService':'Dispositivos totales en servicio',
        'hostTotalUnknownService':'Dispositivos totales desconocidos',
        'hostTotalAfect':'Dispositivos totales afectados',
        'conteoTotalExcep':'Conteo del total de excepciones',
        'listExcept':'Lista de Excepciones',
        'statusInciden':'Estatus de Incidencias',
        'Desastre':'Desastre',
        'Riesgo':'Riesgo',
        'Moderado':'Moderado',
        'Advertencia':'Advertencia',
        'Informativo':'Informativo',
        'hostGeneralInfo':'Informacion general de dispositivo ',
        'AhostSelected':'Dispositivo seleccionado',
        'Alarmas':'Alarmas',
        'salud':'salud',
        'sinRelacionAPS':'Sin relacion con algun APS',
        'valor':'valor',
        'cargando':'cargando',
        'capas':'capas',
        'unMomento':'Un momento por favor',
        'msgLoadingLayers':'Alguno de los siguientes datos estan tardando en cargar, si el problema persiste favor de reportarlo',
        'obteniendoDatos':'Obteniendo datos',
        'diagnosticoEvento':'Diagnostico del evento',/////////////
        'dataHostDiag':'Datos del dispositivo diagnosticado',
        'arrastreHostDependientes':'Arrastre de dispositivo dependientes',
        'conectado':'conectado',
        'desconectado':'desconectado',
        'flujoEvento':'Flujo del evento',
        'enProceso':'EN PROCESO',
        'acumuladoEvento':'Acumulado Evento',
        'disponibilidad':'disponibilidad',
        'promedio':'promedio',
        'lapsoTiempo':'lapso de tiempo',
        'funcPromedio':'funcionalidad promedio',
        'dispPromedio':'disponibilidad promedio',
        'dias':'días',
        'ticketAuto':'ticket automatico',
        'cierreAuto':'cierre automatico',
        'si':'si',
        'no':'no',
        'repetir':'repetir',///////////////////////////////////
        'finalizaRepeticiones':'cantidad de repeticiones para terminar',
        'RepeticionPersonalizadas':'repetición personalizada',
        'repeticiones':'repeticiones',
        'noRepetir':'no repetir',
        'repetirDia':'repetir cada dia',
        'repetirLV':'repetir de lunes a viernes',
        'semanaLavoral':'semana laborables (L-V)',
        'repetirSemana':'repetir cada semana',
        'semanas':'semanas',
        'repetirMes':'repetir cada mes',
        'meses':'meses',
        'repetirAnio':'repetir cada año',
        'anios':'años',
        'personalizar':'personalizar',
        'mapa':'mapa',
        'afiliationMapa':'mapa ubicaciones',
        'indicadores':'indicadores',
        'monitor-mapa':'Monitoreo --> mapa',
        'monitor-mapa-afiliation':'Monitoreo --> mapa ubicaciones',
        'monitor-eventos':'Monitoreo --> eventos',
        'monitor-indicadores':'Monitoreo --> Categorias',
        'monitor-grupos':'Monitoreo --> Grupos',
        'monitor-resets':'Monitoreo --> Resets',
        'general':'general',
        'estacionesTrabajo':'Estaciones de trabajo',
        'impresoras':'Impresoras',
        'telefonos':'Teléfonos',
        'puntosAcceso':'Puntos de Acceso',
        'paginaWeb':'Página Web',
        'enLinea':'en lnea',
        'fueraLinea':'fuera de linea',
        'provicionamiento':'provisionamiento',
        'provicionamiento-config':'provisionamiento --> dispositivos ',
        'provicionamiento-calendario':'provisionamiento --> calendario ',
        'provicionamiento-soft':'provisionamiento --> software ',
        'operativeSistem':'sistema Operativo',
        'sshCredentials':'Credenciales SSH',
        'gestionar':'gestionar',
        'instalar':'instalar',
        'desinstalar':'desinstalar',
        'instalando':'instalando',
        'desistalando':'desistalando',
        'actionComplet':'La accion fue solicitada correctamente',
        'msgActCompl':'La accion se estara ejecutando en segundo plano',
        'errorActionComplet':'La accion no se pudo ejecutar',
        'ConfigCredentials':'configurar credenciales',
        'pruevaSsh':'prueba de conexion ssh',
        'reinicioRequerido':'reinicio requerido',
        'updateAvailable':'actualizaciones disponibles',
        'lastUpdate':'última Actualización',
        'seeUpdate':'ver actualizaciones',
        'saveUpdates':'aplicar Actualizaciones',
        'resetHost':'reiniciar dispositivo',
        'historicUpdates':'historico de actualizaciones',
        'update':'actualización',
        'calendarioProvi':'Calendario ',
        'installMasiva':'instalación masiva',
        'desinstallMasiva':'desinstalación masiva',
        'actualizacionMasiva':'actualización masiva',
        'provicionamiento-auditor':'provisionamiento --> auditor ',
        'fechaRealizacion':'fecha de realización',
        'detalles':'detalles',
        'conectados':'conectados',
        'desconectados':'desconectados',
        'desconocidos':'desconocidos',
        'filtros':'filtros',
        'abrirFiltros':'abrir filtros',
        'cerrarFiltros':'cerrar filtros',
        'busquedaGeneral':'búsqueda general',
        'buscarAfiliacion':'buscar afiliación',
        'resuelto':'resuelto',
        'conAck':'con ack',
        'sinAck':'sin ack',
        'conTicket':'con ticket',
        'sinTicket':'sin ticket',
        'correlacion':'correlación',
        'cierreMasivo':'cierre masivo',
        'eventoCorrelacionado':'evento relacionado',
        'tiempoActual':'tiempo actual',
        'tiempoUltimaCaida':'tiempo última caída',
        'modoDeCierre':'modo de cierre',
        'cerrarTodosLosEventos':'cerrar todos los eventos',
        'cierrePersonalizado':'cierre personalizado',
        'Cerrar eventos normales en resolved':'Cerrar eventos normales en resolved',
        'Cierra únicamente eventos simples (no correlacionados) que se encuentren en estado "resolved". Ignora y no afecta a eventos que tengan relación de padre o hijo.':'Cierra únicamente eventos simples (no correlacionados) que se encuentren en estado "resolved". Ignora y no afecta a eventos que tengan relación de padre o hijo.',
        'Cerrar eventos correlacionados en resolved y sus hijos':'Cerrar eventos correlacionados en resolved y sus hijos',
        'Cierra en cascada un evento padre que esté en "resolved" junto con todos sus eventos hijos correspondientes. Esta acción preserva el vínculo y el historial entre ellos.':'Cierra en cascada un evento padre que esté en "resolved" junto con todos sus eventos hijos correspondientes. Esta acción preserva el vínculo y el historial entre ellos.',
        'Cerrar hijos en resolved aunque el padre siga en problem':'Cerrar hijos en resolved aunque el padre siga en problem',
        'Cierra un evento hijo que ya está en "resolved" pero lo desvincula de su evento padre que continúa en "problem". El evento hijo se archiva en el histórico, guardando una referencia a su correlación original y el padre actualiza su información.':'Cierra un evento hijo que ya está en "resolved" pero lo desvincula de su evento padre que continúa en "problem". El evento hijo se archiva en el histórico, guardando una referencia a su correlación original y el padre actualiza su información.',
        'mensajeDeCierre':'mensaje de cierre',
        'estableciendoConexion':'estableciendo conexión',
        'diagnostico':'diagnóstico',
        'flujo':'flujo',
        'cerrarExcepcion':'cerrar excep.',
        'descargarReporte':'descargar reporte',
        'excepcion':'excepción',
        'seleccionarTecnologia':'seleccionar tecnología',
        'seleccionarGrupo':'seleccionar grupo',
        'seleccionarZona':'seleccionar zona/municipio',
        'crearExcepcion':'crear excepción',
        'notas':'notas',
        'cearAcknownledge':'crear acknowledge',
        'falsoPositivo':'falso positivo',
        'cerrarEvento':'cerrar evento',
        'Solicitud de ticket':'Solicitud de ticket',
        'Creación de evento':'Creación de evento',
        'Creación de ticket':'Creación de ticket',
        'Ticket - Nota interna':'Ticket - Nota interna',
        'Ticket - Avance y solución':'Ticket - Avance y solución',
        'Ticket - Cambio de estatus':'Ticket - Cambio de estatus',
        'Acknowledge':'Acknowledge del evento',
        'Acknowledge del Sistema':'Acknowledge del Sistema',
        'Excepcion': 'Excepción',
        'Cierre de Excepcion':'Cierre de Excepción',
        'Comentario':'Comentario',
        'Progreso del evento a la fecha.':'Progreso del evento a la fecha.',
        'crearTicket':'crear ticket',
        'agregarComentario':'agregar comentario',
        'notaInterna':'nota interna',
        'notaAvanceSolucion':'nota avance y solución',
        'registosSeleccionados':'registros seleccionados',
        'categoria':'categorías',
        'eventoValido':'evento valido',
        'valido':'valido',
        'sinIp':'sin ip',//** */
        'indicadoresportecnologia':'indicadores por tecnología',
        'indicadorsGeneral':'indicadores generales',
        'disponibilidadGeneral':'disponibilidad general',
        'totalDispositivos':'total de dispositivos',
        'tiempo':'tiempo',
        'vista':'vista',
        'gruposSeleccionados':'grupos seleccionados',
        'listadoDispositivos':'listado de dispositivos',
        'interpretado': 'interpretado',
        'sinMetricas':'sin métricas',
        'correlacionDispositivos':'correlación de dispositivos',/////
        'medio': 'medio',
        'hostPadre':'dispositivo padre',
        'hostHijo':'dispositivo hijo',
        'enlace' : 'enlace',
        'traficoSaliente':'tráfico saliente',
        'traficoEntrante':'tráfico entrante',
        'alineacion':'alineación', 
        'crearCorrelacion':'crear correlación entre dispositivos',
        'editarCorrelacion':'editar correlación entre dispositivos',
        'seleccionarDispositivos':'seleccionar dispositivos',
        'seleccionarHostPadre':'seleccionar dispositivo padre',
        'seleccionarHostHijo':'seleccionar dispositivo hijo',
        'seleccionarEnlace':'seleccionar enlace',
        'selectPadreHijo':'Seleccone un host padre y un host hijo',
        'entre':'entre',
        'reporteSNMP':'Reporte SNMP',
        'elemento': 'elemento',
        'segmento':'segmento',
        'segmentoNoValido':'segmento no válido',
        'seleccioneMarca':'seleccione una marca',
        'campoBloqueadoIP':'Campo bloqueado, favor de agregar una IP',
        'ejemplo':'ejemplo',
        'listaDispositivosGroup':'lista de dispositivos para el grupo',
        'ultimaActualizacion':'última actualización',
        'metricasCapturadas':'métricas capturadas',
        'verDetalle':'ver detalle',
        'historico':'histórico',
        'selectMetrica':'seleccionar métrica',
        'selectPermisos':'seleccionar permisos',
        'EditarFrecuencia':'Editar Frecuencia',
        'EditarFrecuenciaReporte':'Editar Frecuencia de Reporte',
        'conectividad':'conectividad',
        'listadoDispositivosMarca':'Listado de dispositivos para la marca',
        'listadoDispositivosModelo':'Listado de dispositivos para el modelo',
        'catalogoMetricas':'Catálogo de métricas',
        'catalogoMapeos':'Catálogo de mapeos',
        'mapeosAplicados':'Mapeos Aplicados',
        'relaciones':'relaciones',
        'fibraOptica':'fibra óptica',
        'microondas':'microondas',
        'torres':'torres',
        'Reporte downs':'Reporte downs',
        'UltimaHora':'Última hora',
        'Ultima3Horas':'Últimas 3 horas',
        'Ultima6Horas':'Últimas 6 horas',
        'Ultima12Horas':'Últimas 12 horas',
        'Ultima24Horas':'Últimas 24 horas',
        'Ultima48Horas':'Últimas 48 horas',
        'estaSemana':'esta semana',
        'semanaPasada':'semana pasada',
        'esteMes':'este mes',
        'mesPasado':'mes pasado',
        'esteAnio':'este año',
        'anioPasado':'año pasado',
        'reintentos':'Reintentos',
        'intentos':'intentos',
        'numeroIntentos':'Número de intentos',
        'crearMapeo':'Crear Mapeo',
        'mapeo':'mapeo',
        'tipoMapeo':'tipo de mapeo',
        'tipoCoincidencia':'tipo de coincidencia',
        'descimalesMostrados':'decimales mostrados',
        'alcance':'alcance',
        'mensajeEvento':'mensaje de evento',
        'solicitar':'solicitar',
        'sinCredenciales':'Sin Credenciales',
        'conCredenciales':'Con Credenciales',
        'provicionamientoDesmantelamiento':'Provicionamiento/Desmantelamiento',
        'actualizaciones': 'actualizaciones',
        'configuracionCredenciales':'Configuración de Credenciales SSH',
        'sistemasOperativos':'Sistemas Operativos',
        'configurar':'configurar',
        'errorCargaHost':'Error al cargar la informacion del host',
        'No se requiere reinicio.':'No se requiere reinicio.',
        'mostrarExcepciones':'Mostrar excepciones',
        'estatusInicial':'estatus inicial'

        
    },  
    
    'en':{
        'inicio':'home',////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        'monitoreo':'monitoring',
        'administrador':'administrator',
        'admin':'administrator',
        'cis':'cmdb',
        'mantto':'maintenance',
        'portafolio':'portfolio',
        'mantenimiento':'maintenance',
        'reportes':'reports',
        'acciones':'actions',
        'buzon':'mailbox',
        'configuracion':'configuration',
        'config':'configuration',
        'salir':'log out',
        'msgCredencialesEstado':'Enter the correct credentials for this status',
        'correo':'mail',
        'contraseña':'password',
        'iniciandoSession':'Log in',
        'credencialesNoAceptadas':'Credentials not accepted',
        'msgUserErrorData':'Your username has errors or is incomplete, please report it to your administrator',
        'pingServer':'Establishing ping with the server ',
        'CargandoDatos':'Loading data, please wait',
        
        'CargandoDatosError':'Loading data, please wait',
        'msgCerrarsession':'Cierre sesion y vuelva a intenar',
        'bienvenido':'welcome',
        'buscar':'search',
        'resultadosEncontrados':'results found',
        'sinResultados':'no results',
        'servicio':'service',
        'nuevoServicio':'new service',
        'regresar':'back',
        'catalogo':'catalog',
        'plantilla':'template',
        'de':'of',
        'resultados':'results',
        'descripcion':'description',
        'severidad':'severity',
        'eliminar':'delete',
        'aceptar':'accept',
        'cancelar':'cancel',
        'msgServicioExiste':'service name already exists',
        'activo':'active',
        'inactivo':'inactive',
        'msgIpNoExiste':'IP does not exist or is not registered',
        'ipNoValida':"Invalid IP address",
        'crear':'create',
        'editar':'edit',
        'nombreServicio':'Service name',
        'guardar':'save',
        'nuevaTecnologia':'new technology',
        'tecnologia':'technology',
        'horas':'hours',
        'msgTecnologiaExiste':'technology name already exists',
        'nombreTecnologia':'Technology name',
        'nuevosDispositivos':'load devices',
        'ubicacion':'location',
        'nuevaConfiguracion':'new Settings',
        'nombre':'name',
        'marca':'brand',
        'modelo':'model',
        'version':'version',
        'noSerie':'serie',
        'criticidad':'criticality',
        'registroConfiguracion':'setting log',
        'coordenadasErroneas':'wrong coordinates',
        'nombreDispositivo':'device name',
        'referencia':'reference',
        'nuevoRegistro':'new registration',
        'tipo':'type',
        'justificacion':'justification',
        'responsable':'responsible',
        'autoriza':'authorizes',
        'fechaInicio':'start date',
        'fechaFin':'end date',
        'afectados':'affected',
        'documentacion':'documentation',
        'afectadoPor':'affected by',
        'agregar':'add',
        'tipoCambio':'exchange rate',
        'accion':'action',
        'aplicados':'applied',
        'exception':'exception',
        'agencia':'agency',
        'tiempoActivo':'active time',
        'closeException':'The exception will be closed',
        'deleteException':'Exception will be eliminated',
        'folio':'folio',
        'quienSolicita':'Who Requests',
        'requizito':'requirement',
        'comentarios':'comments',
        'rechazar':'decline',
        'solicitadoPor':'requested by',
        'config-agency':'Configuration --> Agencies',
        'config-Cis': 'Configuration --> CMDB',
        'criticidades':'criticalities',
        'agencias':'agencies',
        'config-criticity':'Configuration --> Criticalities',
        'icono':'icon',
        'previewIcon':'preview icon',
        'previewLayer':'preview layer',
        'caracteres':'characters',
        'selectColor':'click to select color',
        'agenciaExcepciones': 'Exception agency',
        'noDeleteAgency':'Agency cannot be deleted',
        'noDeleteAgencyDetail':'In order to eliminate this agency, it is necessary to close all the exceptions assigned to it.',
        'nivel':'level',
        'admin-users':'Administration --> Users',
        'admin-rol':'Administration --> Roles',
        'noti-user':'Notifications by user',
        'noti-tec':'Notifications by technology',
        'msgErrorPagina':'Error loading section. Please try again.',
        'nombreNoValido':'Invalid name',
        'correoNoValido':'Invalid email',
        'usuario':'user',
        'usuarios':'users',
        'todos':'all',
        'todas':'all',
        'selecPermisos':'Select permissions',
        'consola':'consola',
        'acciones host':'acciones host',
        'acknownledge':'acknownledge',
        'servidores genetec':'genetec servers',
        'servidores cad':' cad servers',
        'servidores botones':' buttons servers',
        'servidores gemyc':' gemyc servers',
        'link ticket':'link ticket',
        'RESET':'RESET',
        'seleccionar':'select',
        'tecnologias':'technologies',
        'notiTec':'Notification Technologies',
        'notiUser':'Notification Users',
        'reporte-disp': 'Reports --> Availability',
        'reporte-historicDisp':'Reports --> Availability Historic',
        'historicoDisp':'Availability Historic',
        'reporte-disp-host': 'Reports --> Availability by host',
        'grupos': 'groups',
        'grupo': 'group',
        'config-grupos': 'Configuration --> Groups',
        'dispositivos': 'devices',
        'filasPagina': 'rows per page',
        'descargando': 'downloading',
        'importar': 'import',
        'datos': 'data',
        'marcas': 'brands',
        'proxies': 'Monitoring Nodes',
        'config-proxies': 'Configuration --> Monitoring Nodes',
        'config-tec': 'Configuration --> Technologies',
        'config-brand': 'Configuration --> Brands',
        'cerrar': 'close',
        'registrosCargar': 'records to load',
        'sinArchivo': 'No file uploaded',
        'selectFile': 'Select file',
        'registrosCorrectos': 'Successfully registered',
        'updateCorrectos': 'Successfully updated',
        'registrosIncorrectos': 'Invalid records',
        'completado': 'completed',
        'regGenCorr': 'Record generated successfully',
        'regEditCorr': 'Record edited successfully',
        'regNoGenCorr': 'Record not generated successfully',
        'reportError': 'Please report the error',
        'regDeleteCorr': 'Record deleted successfully',
        'importCorr': 'Data import successful',
        'msgImpor': 'Invalid records were detected for import. Please validate them.',  
'msgImporAll': 'All selected records are not valid for import.',  
        'importError': 'Import error',
        'modo': 'mode',
        'lastConect': 'last connection',
        'nombreVisible': 'visible name',
        'modelos': 'models',
        'config-models': 'Configuration --> Models',
        'config-hosts': 'Configuration --> Devices',
        'config-correlacion':'Configuration --> Device Correlations',
        'confGeneral': 'general configuration',
        'confSNMP': 'SNMP Configuration',
        'confMetrica': 'metrics configuration',
        'dispositivo': 'device',
        'municipio': 'municipality',
        'zona': 'zone',
        'latitud': 'latitude',
        'longitud': 'longitude',
        'estatus': 'status',
        'discovery': 'discover',
        'agregarElemento': 'add element',
        'discoverCorrect': 'Data retrieval completed',
        'descargar': 'download',
        'descargaFileCompleta': 'File export or download was successful',
        'config-audit': 'Configuration --> Audit',
        'auditor': 'auditor',
        'fecha': 'date',
        'modulo': 'module',
        'respaldo': 'backup',
        'respaldo-op': 'Backup --> Operation DB Backup',
        'respaldo-config': 'Backup --> Configuration DB Backup',
        'encuestas': 'surveys',
        'encuestas-gen': 'surveys',
        'encuestas-res': 'surveys --> Survey Results',
        'workflow': 'workflow',
        'workflow-gen': 'workflow',
        'gruposUsuarios': 'User Groups',
        'admin-grupos': 'Administration --> User Groups',
        'NotiUsuarios': 'Notifications for users',
        'portafolioServicios': 'Service Portfolio',
        'exepciones': 'Exceptions',
        'calendarioMantenimiento': 'Maintenance Calendar',
        'accionesTecnologia': 'Actions by Technology',
        'solicitudAutoriza': 'Authorization Requests',
        'respaldoConfig': 'DB Backup - Configuration',
        'respaldoOper': 'DB Backup - Operation',
        'encuestasResultados': 'Survey Results',
        'criticidadDispositivo': 'Device Criticalities',
        'gruposDispositivos': 'Device Groups',
        'mediciones': 'Measurements',
        'disparadores': 'Triggers',
        'eventos': 'Events',
        'mediosDifusion': 'Dissemination Media',
        'gruposTelegram': 'Telegram Groups',
        'plantillaTelegram': 'Telegram Templates',
        'lastReadTele': 'Latest Telegram Command Reads',
        'config-mediciones': 'Configuration --> Measurements',
        'config-disparadores': 'Configuration --> Triggers',
        'config-eventos': 'Configuration --> Events',
        'config-medDif': 'Configuration --> Dissemination Media',
        'config-telegram': 'Configuration --> Telegram Groups',
        'config-platelegram': 'Configuration --> Telegram Templates',
        'config-lastReadTele': 'Configuration --> Latest Telegram Command Reads',
        'exportar': 'export',
        'descubrirNuevosGrupos': 'discover new groups',
        'msgVisualisarGrupos': 'To view new groups:',
        'msgVisualisarGrupos1': 'create a group in Telegram from any account',
        'msgVisualisarGrupos2': 'Add as a user the bot: @',
        'msgVisualisarGrupos3': 'Assign admin privileges in the group to the bot: @',
        'msgVisualisarGrupos4': 'Send group authentication code: ',
        'vincular': 'link',
        'gruposDescubiertos': 'Discovered Groups',
        'descubrirGruos': 'discover groups',
        'vinculadoCorrect': 'Group linked successfully',
        'vinculadoInorrect': 'Group not linked successfully',
        'comando': 'command',
        'layout': 'template',
        'vars': 'variables',
        'mensaje': 'message',
        'usuraio': 'user',
        'sendMessage': 'Send Message',
        'sendMessageTest': 'A test message will be sent to the following group',
        'txtAreaMsg': 'Write your message here...',
        'sendMsgCorrect': 'Message sent successfully',
        'sendMsgIncorrect': 'Message not sent successfully',
        'enviar': 'send',
        'manttoCalendar': 'Maintenance Calendar',
        'mantto-excepciones': 'Maintenance --> Exceptions',
        'mantto-calendar': 'Maintenance --> Calendar',
        'titulo': 'title',
        'alertas': 'alerts',
        'evento': 'event',
        'closeEvents': 'The event will close',
        'rangoFechas': 'date range',
        'tipoMantenimiento': 'maintenance type',
        'afiliacion': 'location',
        'hostSelected': 'Selected devices',
        'Aceptar': 'Accept',
        'codigo': 'code',
        'disparador': 'trigger',
        'periodo': 'period',
        'preguntas': 'questions',
        'pregunta': 'question',
        'opciones': 'options',
        'opcion': 'option',
        'respuestas': 'answers',
        'respuesta': 'answer',
        'responder': 'respond',
        'testGenCorr': 'Survey answered successfully',
        'testInCorr': 'An error occurred while recording your answers',
        'tipoAgente': 'agent type',
        'tipoVariable': 'variable type',
        'unidad': 'unit',
        'actualizacion': 'update',
        'plantillas': 'templates',
        'itemName': 'item name',
        'keyItem': 'item key',
        'metrica': 'metric',
        'intervaloActualizacion': 'update interval',
        'templateGroup': 'template group',
        'templateName': 'template name',
        'medicion': 'measurement',
        'maxValue': 'maximum value',
        'minValue': 'minimum value',
        'msgEvento': 'event message',
        'recursos': 'resources',
        'siguiente': 'next',
        'notficacion': 'notification',
        "workflowAction": "action flow",
        "workflow-action": "workflow --> action flow",
        "aplazar": "postpone",
        "historicoEvents": "historical events",
        "eventsTickets": "events vs tickets",
        "reporte-eventos-historic": "Reports --> historical events",
        "reporte-eventos-tickets": "Reports --> events vs tickets",
        "fechaCreacion": "creation date",
        "fechaRecuperacion": "recovery date",
        "fechaCierre": "closure date",
        "eventosDesconeccion": "disconnection events",
        "conteoTickets": "ticket count",
        "espacioTotal": "total space",
        "espacioUtilizado": "used space",
        "configRespaldo": "backup configuration",
        "frecuencia": "frequency",
        "hora": "hour",
        "diario": "daily",
        "semanal": "weekly",
        "diaSemana": "day of the week",
        "lunes": "Monday",
        "martes": "Tuesday",
        "miercoles": "Wednesday",
        "jueves": "Thursday",
        "viernes": "Friday",
        "sabado": "Saturday",
        "domingo": "Sunday",
        "actualizar": "update",
        "backHistory": "backup history",
        "fechaRespaldo": "backup date",
        "configRespaldoComplete": "backup configuration updated",
        "configRespaldoError": "error updating configuration",
        "nuevaPetición": "new request",
        "enviarPetcion": "send request",
        "msgSendRequest": "Submit your request, and the support team will contact you as soon as possible.",
        "tipoPeticion": "request type",
        "seleccionarOpcion": "select option",
        "dataRecovery": "data recovery",
        "dataDestruction": "data destruction",
        "reporte-BI": "Reports --> BI",
        "Incidencia": "Incident",
        "Estatus": "Status",
        "tiempoEvento": "time",
        "problema": "problem",
        "LastAck": "last ack",
        "tiempoGarantia": "warranty time",
        "regDeleteNoCorr": "could not delete the record",
        "reporte-kpi": "Reports --> KPI's",
        "reporte-graph-kpi": "Reports --> KPI's",
        "grafica": "chart",
        "reporte-graph-metrica": "Reports --> Measurement",
        "tipoOperacion": "operation type",
        'conexionesEstado': 'Connections by State',
        'hostTotalService': 'Total Devices in Service',
        'hostTotalUnknownService': 'Total Devices in Unknown Service',
        'hostTotalAfect': 'Total Devices Affected',
        'conteoTotalExcep': 'Total Exceptions Count',
        'listExcept': 'Exceptions List',
        'statusInciden': 'Incident Status',
        'Desastre': 'Disaster',
        'Riesgo': 'Risk',
        'Moderado': 'Moderate',
        'Advertencia': 'Warning',
        'Informativo': 'Informative',
        'hostGeneralInfo': 'Device General Information',
        'AhostSelected': 'Selected Device',
        'Alarmas': 'Alarms',
        'salud': 'Health',
        'sinRelacionAPS': 'No Relation with any APS',
        'valor':'value',
        'cargando':'loading',
        'capas':'layers',
        'unMomento':'One moment please',
        'msgLoadingLayers':'Some of the following data are taking a long time to load, if the problem persists please report it',
        'obteniendoDatos':'Loading data',
        'diagnosticoEvento': 'Event Diagnosis',
        'dataHostDiag': 'Diagnosed Device Data',
        'arrastreHostDependientes': 'Dependent Device Drag',
        'conectado': 'connected',
        'desconectado': 'disconnected',
        'flujoEvento': 'Event Flow',
        'enProceso': 'IN PROCESS',
        'acumuladoEvento': 'Event Accumulated',
        'disponibilidad':'availability',
        'promedio': 'average',
        'lapsoTiempo': 'time lapse',
        'funcPromedio': 'average functionality',
        'dispPromedio': 'average availability',
        'dias':'days',
        'ticketAuto':'automatic ticket',
        'cierreAuto':'automatic closing',
        'si':'yes',
        'no':'no',
        'repetir': 'repeat',
    'finalizaRepeticiones': 'number of repetitions to finish',
    'RepeticionPersonalizadas': 'custom repetition',
    'repeticiones': 'repetitions',
    'noRepetir': 'do not repeat',
    'repetirDia': 'repeat every day',
    'repetirLV': 'repeat from Monday to Friday',
    'semanaLavoral': 'working week (M-F)',
    'repetirSemana': 'repeat every week',
    'semanas': 'weeks',
    'repetirMes': 'repeat every month',
    'meses': 'months',
    'repetirAnio': 'repeat every year',
    'anios': 'years',
    'personalizar': 'customize',
    'mapa': 'map',
    'afiliationMapa': 'affiliation map',
    'indicadores': 'indicators',
    'monitor-mapa': 'Monitoring --> map',
    'monitor-mapa-afiliation':  'Monitoring --> map  affiliation',
    'monitor-eventos':'Monitoring --> events',
    'monitor-indicadores':'Monitoring --> Categories', //'Monitoring --> Devices',
    'monitor-grupos':'Monitoring --> Groups',
    'monitor-resets':'Monitoreo --> Resets',
    'general': 'general',
    'estacionesTrabajo': 'Workstations',
    'impresoras': 'Printers',
    'telefonos': 'Phones',
    'puntosAcceso': 'Access Points',
    'paginaWeb': 'Website',
    'enLinea': 'online',
    'fueraLinea': 'offline',
    'provicionamiento': 'provisioning',
    'provicionamiento-config': 'provisioning --> devices',
    'provicionamiento-calendario': 'provisioning --> calendar',
    'provicionamiento-soft': 'provisioning --> software',
    'operativeSistem': 'Operating System',
    'sshCredentials': 'SSH Credentials',
    'gestionar': 'manage',
    'instalar': 'install',
    'desinstalar': 'uninstall',
    'instalando': 'installing',
    'desistalando': 'uninstalling',
    'actionComplet': 'The action was successfully requested',
    'msgActCompl': 'The action will be executed in the background',
    'errorActionComplet': 'The action could not be executed',
    'ConfigCredentials': 'configure credentials',
    'pruevaSsh': 'SSH connection test',
    'reinicioRequerido': 'restart required',
    'updateAvailable': 'updates available',
    'lastUpdate': 'last update',
    'seeUpdate': 'view updates',
    'saveUpdates': 'apply updates',
    'resetHost': 'restart device',
    'historicUpdates': 'update history',
    'update': 'update',
    'calendarioProvi': 'calendar',
    'installMasiva': 'mass installation',
    'desinstallMasiva': 'mass uninstallation',
    'actualizacionMasiva': 'mass update',
    'provicionamiento-auditor': 'provisioning --> auditor',
    'fechaSolicitud': 'request date',
    'fechaRealizacion': 'completion date',
        'detalles':'details',
        'conectados':'connected',
        'desconectados':'disconnected',
        'desconocidos':'unknown',
        "filtros": "filters",
  "abrirFiltros": "show filters",
  "cerrarFiltros": "hide filters",
  "busquedaGeneral": "global search",
  "buscarAfiliacion": "search by affiliation",
  "resuelto": "resolved",
  "conAck": "acknowledged",
  "sinAck": "unacknowledged",
  "conTicket": "with ticket",
  "sinTicket": "without ticket",
  "correlacion": "correlation",
  "cierreMasivo": "bulk closure",
  "eventoCorrelacionado": "related alert",
  "tiempoActual": "current time",
  "tiempoUltimaCaida": "last downtime",
  "modoDeCierre": "closure mode",
  "cerrarTodosLosEventos": "close all alerts",
  "cierrePersonalizado": "custom closure",
    'Cerrar eventos normales en resolved': 'Close normal events in "resolved"',
  'Cierra únicamente eventos simples (no correlacionados) que se encuentren en estado "resolved". Ignora y no afecta a eventos que tengan relación de padre o hijo.': 'Closes only simple (non-correlated) events that are in the "resolved" state. It ignores and does not affect events that have a parent-child relationship.',
  'Cerrar eventos correlacionados en resolved y sus hijos': 'Close correlated events in "resolved" and their children',
  'Cierra en cascada un evento padre que esté en "resolved" junto con todos sus eventos hijos correspondientes. Esta acción preserva el vínculo y el historial entre ellos.': 'Closes a parent event in the "resolved" state in cascade along with all its corresponding child events. This action preserves the relationship and history between them.',
  'Cerrar hijos en resolved aunque el padre siga en problem': 'Close children in "resolved" even if the parent remains in "problem"',
  'Cierra un evento hijo que ya está en "resolved" pero lo desvincula de su evento padre que continúa en "problem". El evento hijo se archiva en el histórico, guardando una referencia a su correlación original y el padre actualiza su información.': 'Closes a child event that is already in "resolved" but unlinks it from its parent event that remains in "problem". The child event is archived in the history, keeping a reference to its original correlation, and the parent event updates its information.',
"mensajeDeCierre": "closure message",
  "estableciendoConexion": "establishing connection",
  "diagnostico": "diagnosis",
  "flujo": "flow",
  "cerrarExcepcion": "close exception",
  'descargarReporte':'download report',
  'excepcion':'exception',
  'seleccionarTecnologia':'select technology',
        'seleccionarGrupo':'select group',
        'seleccionarZona':'select zone/municipality',
          'crearExcepcion': 'create exception',
  'notas': 'notes',
  'cearAcknownledge': 'create acknowledge',
  'falsoPositivo': 'false positive',
  'cerrarEvento': 'close event',
  'Solicitud de ticket': 'ticket request',
  'Creación de evento': 'event creation',
  'Creación de ticket': 'ticket creation',
  'Ticket - Nota interna': 'ticket - internal note',
  'Ticket - Avance y solución': 'ticket - progress and resolution',
  'Ticket - Cambio de estatus': 'ticket - status change',
  'Acknowledge': 'event acknowledge',
  'Acknowledge del Sistema': 'system acknowledge',
  'Excepcion': 'exception',
  'Cierre de Excepcion': 'exception closure',
  'Comentario': 'comment',
  'Progreso del evento a la fecha.': 'event progress to date.',
  'crearTicket': 'create ticket',
  'agregarComentario': 'add comment',
  'notaInterna': 'internal note',
  'notaAvanceSolucion': 'progress and resolution note',
  'registosSeleccionados': 'selected records',
  'categoria': 'Categories',
    'eventoValido': 'valid event',
    'valido': 'valid',
    'sinIp': 'without ip',
    'indicadoresportecnologia':'indicators by technology',
    'indicadorsGeneral':'general indicators',
    'disponibilidadGeneral':'general availability',
    'totalDispositivos':'total devices',
    'tiempo':'time',
    'vista':'view',
    'gruposSeleccionados':'selected groups',
    'listadoDispositivos':'device listing',
    'interpretado': 'interpreted',
    'sinMetricas':'no metrics',
    'correlacionDispositivos':'device correlation',
    'medio': 'medium',
    'hostPadre':'parent device',
    'hostHijo':'child device',
    'enlace' : 'link',
    'traficoSaliente':'outgoing traffic',
    'traficoEntrante':'incoming traffic',
    'alineacion':'alignment',
    'crearCorrelacion':'create correlation between devices',
    'editarCorrelacion':'edit correlation between devices',
    'seleccionarDispositivos':'select devices',
    'seleccionarHostPadre':'select parent device',
    'seleccionarHostHijo':'select child device',
    'seleccionarEnlace':'select link',
    'selectPadreHijo':'Select a parent host and a child host',
    'entre':'between',
    'reporteSNMP':'SNMP Report',
    'elemento': 'element',
    'segmento':'segment',
    'segmentoNoValido':'invalid segment',
    'seleccioneMarca':'select a brand',
    'campoBloqueadoIP':'Field blocked, please add an IP',
    'ejemplo':'example',
    'listaDispositivosGroup':'device list for the group',
    'ultimaActualizacion':'last update',
    'metricasCapturadas':'captured metrics',
    'verDetalle':'view detail',
    'historico':'historical',
    'selectMetrica':'select metric',
    'selectPermisos':'select permissions',
    'EditarFrecuencia':'Edit Frequency',
    'EditarFrecuenciaReporte':'Edit Report Frequency',
    'conectividad':'connectivity',
    'listadoDispositivosMarca':'Device listing for the brand',
    'listadoDispositivosModelo':'Device listing for the model',
    'catalogoMetricas':'Metric Catalog',
    'catalogoMapeos':'Mapping Catalog',
    'mapeosAplicados':'Applied Mappings',
    'relaciones':'relationships',
    'fibraOptica':'fiber optic',
    'microondas':'microwave',
    'torres':'towers',
    'Reporte downs':'Downs Report',
    'UltimaHora':'Last hour',
    'Ultima3Horas':'Last 3 hours',
    'Ultima6Horas':'Last 6 hours',
    'Ultima12Horas':'Last 12 hours',
    'Ultima24Horas':'Last 24 hours',
    'Ultima48Horas':'Last 48 hours',
    'estaSemana':'this week',
    'semanaPasada':'last week',
    'esteMes':'this month',
    'mesPasado':'last month',
    'esteAnio':'this year',
    'anioPasado':'last year',
    'reintentos':'Retries',
    'intentos':'attempts',
    'numeroIntentos':'Number of attempts',
    'crearMapeo':'Create Mapping',
    'mapeo':'mapping',
    'tipoMapeo':'mapping type',
    'tipoCoincidencia':'matching type',
    'descimalesMostrados':'displayed decimals',
    'alcance':'scope',
    'mensajeEvento':'event message',
    'solicitar':'request',
    'sinCredenciales':'Without Credentials',
    'conCredenciales':'With Credentials',
    'provicionamientoDesmantelamiento':'Provisioning/Decommissioning',
    'actualizaciones': 'updates',
    'configuracionCredenciales':'SSH Credentials Configuration',
    'sistemasOperativos':'Operating Systems',
    'configurar':'configure',
    'errorCargaHost':'Error loading host information',
    'No se requiere reinicio.':'No restart required.',
    'mostrarExcepciones':'Show exceptions',
    'estatusInicial':'initial status'


    
    

        
        
        
    }
}

export {lang}